var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from "react";
import { FormattedMessage, defineMessages, injectIntl } from "react-intl";
import { Field, reduxForm } from "redux-form/immutable";
import SuccessChangeProfile from "./SuccessChangeProfile";
import ProfileInput from "./ProfileInput";
var passwordFields = [
    {
        name: "CurrentPassword",
        placeholder: "Текущий пароль",
        type: "password",
        formatMessage: "profile_current_pass"
    },
    {
        name: "Password",
        placeholder: "Новый пароль",
        type: "password",
        formatMessage: "profile_new_pass"
    },
];
var messages = defineMessages({
    profile_new_pass: {
        id: "profile.new_pass",
        defaultMessage: "Новый пароль"
    },
    profile_confirm_pass: {
        id: "profile.confirm_pass",
        defaultMessage: "Подтвердите пароль"
    },
    profile_current_pass: {
        id: "profile.current_pass",
        defaultMessage: "Введите текущий пароль"
    },
    profile_pass: {
        id: "profile.pass",
        defaultMessage: "Пароль"
    },
    profile_save: {
        id: "profile.save",
        defaultMessage: "Сохранить"
    },
    profile_change: {
        id: "profile.change",
        defaultMessage: "Изменить"
    },
    profile_password_not_same: {
        id: "profile.password_not_same",
        defaultMessage: "Пароли не совпадают"
    },
    profile_password_saved_success: {
        id: "profile.password_saved_success",
        defaultMessage: "Пароль успешно изменен"
    },
    profile_min_length_new_pass: {
        id: "profile.min_length_new_pass",
        defaultMessage: "Новый пароль должен содержать не менее 6 символов"
    }
});
var ChangePasswordProfile = /** @class */ (function (_super) {
    __extends(ChangePasswordProfile, _super);
    function ChangePasswordProfile() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChangePasswordProfile.prototype.render = function () {
        var _a = this.props, submitAction = _a.submitAction, handleSubmit = _a.handleSubmit, isSuccessPasswordChange = _a.isSuccessPasswordChange, clickOk = _a.clickOk;
        if (isSuccessPasswordChange) {
            return _jsx(SuccessChangeProfile, { clickOk: clickOk, message: this.props.intl.formatMessage(__assign({}, messages.profile_password_saved_success)) });
        }
        return (_jsxs("form", __assign({ onSubmit: handleSubmit(submitAction) }, { children: [passwordFields.map(function (passwordField) {
                    return (_jsx(FormattedMessage, __assign({}, messages[passwordField.formatMessage], { children: function (m) { return (_jsx(Field, { component: ProfileInput, name: passwordField.name, placeholder: m, type: passwordField.type })); } }), passwordField.name));
                }), _jsx("div", __assign({ className: "controls" }, { children: _jsx(FormattedMessage, __assign({}, messages.profile_change, { children: function (m) { return (_jsx("button", __assign({ type: "submit", name: "save" }, { children: m }))); } })) }))] })));
    };
    return ChangePasswordProfile;
}(Component));
ChangePasswordProfile = reduxForm({
    form: "profile-form"
})(ChangePasswordProfile);
export default injectIntl(ChangePasswordProfile);



// WEBPACK FOOTER //
// ./src/components/profile/ChangePasswordProfile.jsx